export default function ofType(array, ctor) {
    const result = [];
    for (const item of array) {
        if (item instanceof ctor) {
            result.push(item);
        }
    }
    return result;
}
